export enum RoleType {
  CUSTOMER = 'customer',
  STAFF = 'staff',
  REGIONAL_REPRESENTATIVE = 'regionalRepresentative',
  ADMIN = 'admin',
  SECRETARY = 'secretary'
}
